{
  "testMark": "测试票 · 不作为消费凭证",
  "shopName": "碧海示例门店",
  "chainName": "碧海生活",
  "orderNumber": "108",
  "time": "2026-09-13 12:30:00",
  "tableName": "",
  "salePoint": "本机收银",
  "fulfillment": "自提",
  "customerName": "示例会员",
  "staffName": "测试员",
  "amount": "56.00",
  "payment": "现金 ¥56.00",
  "deliveryName": "",
  "deliveryAddress": "",
  "subject": "桌台：大厅 A08",
  "person": "2",
  "action": "加菜",
  "totalQty": "3",
  "name": "鲜萃茉莉轻乳茶（超长商品名称换行示例）",
  "specText": "大杯 / 少冰 / 三分糖 / 加珍珠",
  "commit": "请分开打包",
  "index": "1",
  "total": "2",
  "items": [
    {
      "name": "鲜萃茉莉轻乳茶（超长商品名称换行示例）",
      "specText": "大杯 / 少冰 / 三分糖 / 加珍珠",
      "commit": "请分开打包",
      "qty": "2",
      "price": "18.00",
      "subtotal": "36.00"
    },
    {
      "name": "手作红豆奶茶",
      "specText": "热 / 无糖",
      "commit": "",
      "qty": "1",
      "price": "20.00",
      "subtotal": "20.00"
    }
  ],
  "pickupMemberName": "示例会员",
  "pickupPhoneTail": "5678",
  "deliveryPhone": "",
  "pickupMemberDisplay": "示例会员 138****5678"
}
